import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors, AsyncValidatorFn, ValidatorFn } from '@angular/forms';
import { ClientAdminService } from 'src/app/business-service/client-admin/client-admin.service';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { ComponentReloadService } from 'src/app/modules/shared/services/reload/component-reload.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { AdminService } from 'src/app/business-service/admin/admin.service';
import { map, catchError, of, Observable } from 'rxjs';
import { LovDataService } from 'src/app/modules/shared/services/lov-data/lov-data.service';
import { InputValidationsService } from 'src/app/modules/shared/services/validations/input-validations.service';
import { ModalsService } from 'src/app/modules/shared/services/modals/modals.service';
import { RECORD_STATUS_VALUES, USER_ROLES } from 'src/app/modules/shared/constants/api-constants';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
})
export class UserDetailsComponent implements OnInit {
  @Output() formSubmitted = new EventEmitter<any>();
  @Output() goPreviousStep = new EventEmitter<void>();
  @Output() emitUserId = new EventEmitter<any>();
  @Output() emitAddUserdetails = new EventEmitter<any>();
  @Output() assignUserAccessData = new EventEmitter<any>();

  @Output() updateUserDetails = new EventEmitter<any>();
  @Output() submitUser = new EventEmitter<any>();

  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() userId: any;
  @Input() editUserId: any;
  @Input() addUserDetails: any;
  @Input() organizationType: string = '';
  originalUserEmail:any;

  // exisitingUserEmails: any;
  exisitingUserEmails: any[] = [];

  userForm!: FormGroup;
  rolesList: any[] = [];
  constructor(
    private fb: FormBuilder,
    private _userService: ClientAdminService,
    private _globalService: GlobalService,
    private _responseNotificationService: ResponseNotificationService,
    private _reloadService: ComponentReloadService,
    private _adminService: AdminService,
    private _lovDataService: LovDataService,
    private _validationService: InputValidationsService,
    private _modalService: ModalsService,
  ) { }

  async ngOnInit() {
    this.loadRoles();
    if(this.addUserDetails){
      this.originalUserEmail = this.addUserDetails.email;
    }
    // await this.loadExistingUserEmail();

    this.userForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]+$')]],
      lastName: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]+$')]],
      onBoardedDate: [this.today],
      activationDate: [ null],
      personalPhoneNumber: [{ countryCode: '+91', phone: '' }],
      officePhoneNumber: [{ countryCode: '+91', phone: '' }, [Validators.required]],
      email: ['', [Validators.required, this._validationService.emailValidator(), this.emailCheckForUser()]],
      roleIdentifier: ['', Validators.required],
      department: ['', Validators.required],
      dateOfBirth: [null],
      gender: ['', Validators.required],
      status: [''],
      imagePath: [''],
      imageDoc: [''],
      id: [null],
      createDate: [''],
      createdBy: [''],
      ownershipRole: [''],
      userId: [null],
      organizationId: [null],
    });

    this.userForm.valueChanges.subscribe(() => {
      this.userForm.markAsTouched();
    });

    if (this.addUserDetails) {      
      this.patchUserFormData(this.addUserDetails);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
  if (changes['organizationType'] && this.organizationType) {
    this.loadExistingUserEmail();
  }

  if (changes['addUserDetails'] && this.addUserDetails && this.userForm && !this.userForm.dirty) {
    this.originalUserEmail = this.addUserDetails.email;
    this.patchUserFormData(this.addUserDetails);
  }
}

  convertToDate(date: any):any {
    if (date) {
      return new Date(date);
    }
    return null;
  }

  emailCheckForUser(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const userEmail = control.value.trim().toLowerCase();
    const original = this.originalUserEmail?.trim().toLowerCase();

    const taken = (this.exisitingUserEmails ?? [])
      .map((e: string) => e?.trim().toLowerCase())
      .filter((e: string) => e && e !== original);

    return taken.includes(userEmail) ? { emailTaken: true } : null;
  };
}

  patchUserFormData(formData: any) {
    this.userForm.patchValue({
      ...formData,
      gender: formData.gender || "",
      department: formData.department || "",
      onBoardedDate: formData.onBoardedDate || null,
      activationDate: formData.activationDate || null,
      imagePath: formData.imagePath,
      imageDoc: formData.imagePath
    });

    // disabled email field
    if(formData.status === RECORD_STATUS_VALUES.ACTIVE){
      this.userForm.get('email')?.disable();
    }
      this.applyRoleDropdownPermission(formData.roleIdentifier);
    
    }

async loadExistingUserEmail(): Promise<void> {
  if (!this.organizationType) {
    return;
  }

  return new Promise((resolve, reject) => {
    this._adminService.getUserEmails(this.organizationType).subscribe({
      next: (res: any) => {
        this.exisitingUserEmails = res;
        resolve();
      },
      error: (error: any) => {
        console.error("Error while fetching user emails", error);
        reject(error);
      }
    });
  });
}

  get today(): Date {
    return new Date();
  }

  // attachment funtions
  getImgUrl(file: any) {
    if (file instanceof File) {
      const fileURL = URL.createObjectURL(file);
      return fileURL;
    } else {
      return file;
    }
  }

  onProfileChange(event: any) {
    const file = event.target.files[0];
    // Checking if image is more than 5MB
    if (file.size > 5 * 1024 * 1024) {
      this._globalService.customAlert("File size should be less than 5MB", "Invalid File Size");
      return;
    }
    
    if (file) {
      const formData = new FormData();
      formData.append('image', file);
      this._lovDataService.uploadImage(formData, "user").subscribe({
        next: (res) => {
          this.userForm.get('imagePath')?.setValue(res);
          this.userForm.get('imageDoc')?.setValue(file);
          this.userForm.markAsDirty();
        },
        error: (error) => {
          console.error('Error uploading image: ', error);
          this._responseNotificationService.showMessage("Error uploading image", true);
        }
      })
    }
  }

  openAttachment(file: any) {
    this._modalService.openImageModal(this.getImgUrl(file));
  }

  deleteProfileImage() {
    this.userForm.get('imagePath')?.setValue(null);
    this.userForm.get('imageDoc')?.setValue(null);
    this.userForm.markAsDirty();
  }

  async onSubmit(): Promise<boolean> {
    if (this.userForm.valid) {
      try {
        const formData = this.userForm.getRawValue();
        this.userForm.markAsPristine();
        this.emitAddUserdetails.emit(formData);
        this.submitUser.emit();
        return true;
      } catch (error) {
        console.error("Error while adding visa info", error);
        return false;
      }
    } else {
      this.userForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Fill all required fields to save", "Invalid Form");
      return false;
    }
  }

  async resetForm() {
    if (await this._globalService.confirmActionPopup('Confirm to reset data', 'Confirm', 'Confirm')) {
      this.ngOnInit();
    }
  }

  goPrevious() {
    this.viewChange.emit(true);
  }

  goNextTab() {
    this.viewChange.emit(false);
  }

  async saveAndNext() {
    if (await this.onSubmit()) {
      this.goNextTab();
    }
  }

  formDataModified(): boolean {
    return (this.userForm.dirty || this.userForm.invalid) && this.userForm.touched;
  }

//retive roles and validation for the Client Super Admin  
loadRoles() {
  this._lovDataService.getLovData('UserRoles').subscribe({
    next: (res: any) => {
      this.rolesList = res.filter((role: any) => role.key !== USER_ROLES.CLIENT_SUPER_ADMIN);
    },
    error: (err) => {
      console.error('Error fetching roles', err);
    }
  });
}


ensureCurrentRoleVisible(targetUserRole: string) {
  const roleExistsInList = this.rolesList.some((r: any) => r.key === targetUserRole);
  if (!roleExistsInList) {
    this._lovDataService.getLovData('UserRoles').subscribe({
      next: (res: any) => {
        const missingRole = res.find((r: any) => r.key === targetUserRole);
        if (missingRole) {
          this.rolesList = [missingRole, ...this.rolesList];
        }
      }
    });
  }
}

applyRoleDropdownPermission(targetUserRole: string) {
  const currentRole = localStorage.getItem('Role');
  const currentUserId = localStorage.getItem('userId');
  const targetUserId = this.addUserDetails?.userId;
  let shouldDisable = false;

  if (currentRole === USER_ROLES.CLIENT_SUPER_ADMIN) {
    if (String(targetUserId) === String(currentUserId)) {
      shouldDisable = true;
    }
  } else if (currentRole === USER_ROLES.CLIENT_ADMIN) {
    if (
      targetUserRole === USER_ROLES.CLIENT_SUPER_ADMIN ||
      targetUserRole === USER_ROLES.CLIENT_ADMIN
    ) {
      shouldDisable = true;
    }
  } else {
    shouldDisable = true;
  }

  this.ensureCurrentRoleVisible(targetUserRole);

  if (shouldDisable) {
    this.userForm.get('roleIdentifier')?.disable();
  } else {
    this.userForm.get('roleIdentifier')?.enable();
  }
}
}